export const STORE_UI = 'uiStore';
export const STORE_USER = 'userStore';
export const STORE_ROUTER = 'routerStore';
export const STORE_EMPLOYER = 'employerStore';
export const STORE_ADMIN = 'adminStore';
export const STORE_PAYROLL = 'payrollStore';
export const STORE_HR = 'hrStore';
